// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { FlexColumn, FlexRow, H3, palette, shadows, spacing } from '@alto/pocky';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import autobind from 'autobind-decorator';
import React from 'react';
import styled from 'styled-components';

type Props = {
  readonly children: any;
  readonly title: string;
  readonly darkHeader: boolean | null | undefined;
};

type State = {
  collapsed: boolean;
};
const Container = styled(FlexRow)`
  ${shadows.boxShadow1};
  border-radius: ${spacing.borderRadius};
  margin-bottom: ${spacing.mdSpacing};
`;

const Header = styled(FlexColumn)<{ darkHeader: boolean | null | undefined }>`
  background-color: ${({ darkHeader }) => (darkHeader ? palette.warmGrey : palette.altoColorsW)};
  border: 1px solid ${palette.grey2};
  border-bottom: none;
  cursor: pointer;
  height: 3rem;
  padding: 0 ${spacing.mdSpacing};
`;

export default class CollapsibleSection extends React.PureComponent<Props, State> {
  state = {
    collapsed: false,
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  toggleCollapse() {
    this.setState((state) => ({
      collapsed: !state.collapsed,
    }));
  }

  render() {
    const { children, title, darkHeader } = this.props;
    const { collapsed } = this.state;

    return (
      <Container>
        <Header
          evenlySpaceContent
          // eslint-disable-next-line @typescript-eslint/unbound-method
          onClick={this.toggleCollapse}
          verticallyAlignContent
          darkHeader={darkHeader}
        >
          <H3>{title}</H3>
          <FontAwesomeIcon
            color={palette.grey1}
            icon={collapsed ? faChevronDown : faChevronUp}
          />
        </Header>
        {collapsed ? null : children}
      </Container>
    );
  }
}
